/**
 * 미리듣기 제한 시간 (초)
 * 구매하지 않은 사용자는 15초까지만 재생 가능
 */
export const PREVIEW_DURATION = 15;

/**
 * Seek 에러 최대 허용 횟수
 * 이 횟수를 초과하면 seeking 기능 비활성화
 */
export const MAX_SEEK_ATTEMPTS = 3;

/**
 * 오디오 플레이어 초기 볼륨 (0.0 ~ 1.0)
 */
export const DEFAULT_VOLUME = 0.7;

/**
 * 오디오 미디어 에러 메시지
 */
export const AUDIO_ERROR_MESSAGES = {
  SEEK_DISABLED: '이 음원은 구간 이동이 지원되지 않습니다. 처음부터 재생해주세요.',
  PREVIEW_LIMIT: 'Seek blocked: Preview limited to 15 seconds',
  PLAY_ERROR: 'Play error occurred',
  TOGGLE_ERROR: 'Toggle play error occurred',
  SEEK_ERROR: 'Seek error occurred',
} as const;
